/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { TFunction } from "i18next";

import { IExceptionModel } from "../models";

export class ErrorHelper {
  static getApiError = (error: unknown): IExceptionModel | undefined => {
    if (!error || typeof error !== "object") {
      return undefined;
    }

    return error as IExceptionModel;
  };

  static getApiErrorMessage = (
    error: unknown,
    t: TFunction,
    fallbackKey: string,
  ): string => {
    if (error instanceof Error) {
      const translatedClientError = t(error.message);
      if (translatedClientError !== error.message) {
        return translatedClientError;
      }
    }

    const apiError = ErrorHelper.getApiError(error);

    if (apiError?.MessageKey) {
      const translated = t(apiError.MessageKey);
      if (translated !== apiError.MessageKey) {
        return translated;
      }
    }

    if (apiError?.Message) {
      return apiError.Message;
    }

    return t(fallbackKey);
  };
}
